// Module
var code = "<style>viewer{position:relative;overflow:hidden;z-index:1;justify-content:center;align-items:center;width:100%;height:100%}.babylonjs-canvas{flex:1;width:100%;height:100%;touch-action:none}</style> <canvas class=\"babylonjs-canvas\" touch-action=\"none\"> </canvas> <nav-bar></nav-bar>";
// Exports
module.exports = code;